<template>
  <ValidationObserver v-slot="{ invalid }">
    <vx-card
      :title="$t('class-over-view.instruction')"
      class="mb-base"
      title-color="primary"
    >

      <template slot="actions">
        <vx-tooltip :text="$t('general.edit')" class="float-right">
          <vs-button :disabled="local.isProcessing"
                     @click.prevent="onEditClick" color="primary" icon="icon-edit"
                     icon-pack="feather" radius
                     size="small" type="filled">
          </vs-button>
        </vx-tooltip>
      </template>

      <!--EDIT FORM-->
      <div v-if="showEditForm">
        <div class="vx-row">

          <div class="vx-col w-full">
            <vs-textarea class="w-full" rows="6"
                         v-model="courseOutline.instruction"></vs-textarea>
          </div>

<!--          <div class="vx-col sm:w-1/2 w-full">
            <p>{{ $t('course-outline.upload-instruction-vdo') }}</p>
            &lt;!&ndash;<div id="uploadVdoInput">
              <vs-upload-mod :accept="uploadAcceptVdoType"
                             :action="uploadVdoUrl"
                             :data="uploadPayload"
                             :headers="headers"
                             :multiple="false"
                             :text="$t('vdo-set-topic.upload-vdo')"
                             @change="onFileUploadChange"
                             @on-error="onUploadError"
                             @on-success="onUploadSuccess"
                             automatic
                             :showUploadButton="false"
                             class="m-0 p-0"
              />
            </div>&ndash;&gt;
          </div>-->

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mt-3">
            <vs-button :disabled="local.isProcessing || invalid "
                       @click.prevent="onSaveClick"
                       color="primary">
              {{ $t('general.save') }}
            </vs-button>

            <vs-button @click.prevent="onCancelClick" class="ml-2" color="warning"
                       type="border">
              {{ $t('general.cancel') }}
            </vs-button>
          </div>
        </div>

      </div>

      <!--DISPLAY DATA-->
      <div class="p-1 mb-2" v-else>

        <div class="vx-row">

          <div class="vx-col w-full">
<!--            <p v-if="courseOutlineCompute.instruction">
              {{ courseOutlineCompute.instruction ? courseOutlineCompute.instruction:'-' }}
            </p>-->
            <vs-textarea v-if="courseOutlineCompute.instruction"
                         class="w-full"
                         rows="6"
                         disabled="disabled"
                         v-model="courseOutlineCompute.instruction">
            </vs-textarea>
            <p class="text-grey" v-else>{{ $t('course-outline.no-data') }}</p>
          </div>

<!--          <div class="vx-col sm:w-1/2 w-full">
            <p class="text-grey" v-if="!courseOutlineCompute.streamIntroPath">{{ $t('course-outline.no-data') +$t('course-outline.instruction-vdo')}}</p>
            &lt;!&ndash;VIDEO HERE&ndash;&gt;

          </div>-->

        </div>

      </div>

    </vx-card>
  </ValidationObserver>
</template>

<script>
  import {state} from "../data";
  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";
  import {config} from "@/utils/upload";
  import {showStateNotification, showLocalNotification, notificationType} from "@/utils/notification";
  // import vsUploadMod from '@/components/vuesax-mod/components/vsUpload/vsUpload';
  import {getECode, getRStage, getToken} from "@/utils/auth-data";

  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);

  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    props: {
      courseOutline: Object
    },
    components: {
      // vsUploadMod,
    },
    data() {
      return {
        showEditForm: false,

        store: state.store,
        local: state.local,

        uploadAcceptVdoType: config.fileExtension.video,
        uploadVdoUrl: config.url.vdoOnDemandApi,
        uploadPayload: {
          fileName: '',
          courseOutlineId: '',
          vdoLength: 0,
          r_stage: getRStage,
          e_code: getECode,
          authorization: getToken,
          app: "admin"
        },
        headers:{
          'content-type': 'multipart/form-data',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "Content-Type, Accept",
          'Access-Control-Allow-Credentials': true
        }
      }

    },
    computed: {
      ...mapCourseOutlineFields({
        courseOutlineProcessing: 'processing'
        , courseOutlineSuccess: 'success', courseOutlineError: 'error'
      }),
      courseOutlineCompute() {
        return this.courseOutline ? this.courseOutline : {}
      },
      isUploading() {
        return this.local.isUploading
      },
    },
    watch: {
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      courseOutlineError: async function (data) {
        showStateNotification(this.$vs, data);
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseOutlineActions({
        updateCourseOutline: 'updateCourseOutline',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onEditClick() {
        this.showEditForm = !this.showEditForm;

      },
      async onSaveClick() {

        let payload = {
          id: this.courseOutline.id,
          courseOutlineInput: {
            instruction: this.courseOutline.instruction,
          }
        }
        await this.updateCourseOutline(payload);

        this.showEditForm = false;

      },
      onCancelClick() {
        this.showEditForm = false;
      },
      async onFileUploadChange(event, files) {
        this.local.isUploading = true;
        this.setVdoInfo(files, this.uploadPayload);
      },
      async onUploadSuccess() {
        //call update function
        showLocalNotification(this.$vs, this.$t('general.success')
          , this.$t('upload.upload-vdo-success', {fileName: this.uploadPayload.fileName})
          , notificationType.SUCCESS);
        this.local.isUploading = false;
      },
      onUploadError() {
        showLocalNotification(this.$vs, this.$t('general.error')
          , this.$t('upload.upload-vdo-fail', {fileName: this.uploadPayload.fileName})
          , notificationType.ERROR);
        this.local.isUploading = false;
      },
      setVdoInfo(files, uploadPayload) {
        //set upload file name
        let fileExtension = files[0].name.split('.').pop();
        uploadPayload.fileName = files[0].name;
        uploadPayload.fileNameUpload = config.prefixFileName.vdoOnDemand
          + '_' + this.courseOutline.subject.code
          + '_' + this.courseOutline.teacher.code
          + '_' + this.courseOutline.id
          + '.' + fileExtension;
        //set id for api to update path at backend
        uploadPayload.courseOutlineId = this.courseOutline.id

        //set video info
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          uploadPayload.vdoLength = video.duration;
        }
        video.src = URL.createObjectURL(files[0]);

        return video;
      }

      //---------------------------------------- Local Function ------------------------------------------------------//

    }
  }
</script>

<style scoped>

</style>
